import { jsx as _jsx } from "react/jsx-runtime";
import PageLayout from '../../../layout/page-layout';
import { DiscussionNew } from '../../_shared/discussions';
import { useAuth } from '../../../hooks/useAuth';
import { districtRoutes } from '../../../common/routes/district';
function DistrictDiscussionNew() {
    const [auth] = useAuth();
    if (!auth.isAuthenticated) {
        return (_jsx(PageLayout, { children: _jsx("div", { className: "bg-light-subtle py-5", children: _jsx("div", { className: "container text-center py-5", children: _jsx("p", { className: "text-muted", children: "Please sign in to start a discussion." }) }) }) }));
    }
    return (_jsx(PageLayout, { children: _jsx("div", { className: "bg-light-subtle py-5", children: _jsx(DiscussionNew, { routes: {
                    listPath: districtRoutes.discussions.getURL(),
                    newPath: districtRoutes.discussionsNew.getURL(),
                    detailPath: (id) => districtRoutes.discussionsDetail.getURL({ id }),
                } }) }) }));
}
export default DistrictDiscussionNew;
